<template>
    <div v-if="modal_visible" class="comp_modal_overlay">
        <!-- MODAL LOGOUT -->
        <div v-if="modal_type == 'modal_logout'" class="modal_overlay" v-bind:class="{ modalShow: modal_visible }">
            <div class="box">
                <header>
                    <h2 class="modal_title">
                        {{ translations.generic.title_logout }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <p class="content">
                        {{ translations.generic.content_logout }}
                    </p>
                    <span class="icon-close-positive-circle close" @click="closeModal"></span>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div class="button black30" @click="closeModal">
                            {{ translations.generic.cancel }}
                        </div>
                        <div class="button" @click="logOut">
                            {{ translations.generic.close_session }}
                        </div>
                    </span>
                </section>
            </div>
        </div>
        <!-- /MODAL LOGOUT -->

        <!-- MODAL LANGUAGE -->
        <div v-if="modal_type == 'modal_language'" class="modal_overlay modal_language"
            v-bind:class="{ modalShow: modal_visible }">
            <div class="box">
                <header>
                    <h2 class="modal_title">
                        {{ translations.menu_lang.title }}
                    </h2>
                </header>
                <section class="info_section">
                    <p class="content">
                        {{ translations.menu_lang.content_info }}
                    </p>
                    <div class="content info_language">
                        <span>
                            <span class="lang_selected"><span class="icon-selected"></span>{{
                                translations.menu_lang.selected_language
                            }}</span>
                        </span>
                        <span>
                            <span class="default_language"><span class="icon-lock"></span>{{
                                translations.menu_lang.default_language
                            }}</span>
                        </span>
                    </div>
                </section>
                <section class="wrapper_inputs">
                    <div class="button btn_menu_language black30" v-for="(lang, lang_key) in App.user.languages"
                        :key="lang_key" :class="[
                            {
                                language_selected:
                                    current_language_selected ==
                                    lang.toLowerCase()
                            }
                        ]">
                        <!-- {{ App.translations.languages }}-{{ lang }}-{{ App.selected_language }} -->
                        <span v-if="true" class="item_1" @click="setLanguageApplication(lang.toLowerCase())">
                            {{ App.translations.languages[lang.toLowerCase()][App.selected_language] }}
                            <span class="sup">{{ lang }}</span>
                        </span>
                        <span class="item_2" @click="
                            setDefaultLanguageApplication(
                                lang.toLowerCase()
                            )
                        ">
                            <i v-if="
                                default_lang_application ==
                                lang.toLowerCase()
                            " class="icon-lock"></i>
                            <i v-if="
                                default_lang_application !=
                                lang.toLowerCase()
                            " class="icon-unlock"></i>
                        </span>
                    </div>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div class="button black30" @click="closeModal">
                            {{ translations.generic.cancel }}
                        </div>
                        <div @click="setAppLanguage" class="button">
                            {{ translations.menu_lang.save_language_selected }}
                        </div>
                    </span>
                    <span class="icon-close-positive-circle close" @click="closeModal"></span>
                </section>
            </div>
        </div>
        <comp_modal_overlay_confirm></comp_modal_overlay_confirm>
        <!-- /MODAL LANGUAGE -->

        <!-- MODAL MARKET -->
        <div v-if="modal_type == 'modal_market'" class="modal_overlay modal_market"
            v-bind:class="{ modalShow: modal_visible }">
            <div class="box">
                <header>
                    <h2 class="modal_title">{{ translations.market.title }}</h2>
                </header>
                <section class="info_section">
                    <p class="content">
                        {{ translations.market.content_info }}
                    </p>
                    <div class="content info_market">
                        <span>
                            <span class="market_selected"><span class="icon-selected"></span>{{
                                translations.market.selected_language
                            }}</span>
                        </span>
                        <span>
                            <span class="default_market"><span class="icon-lock"></span>{{
                                translations.market.default_language
                            }}</span>
                        </span>
                    </div>
                </section>
                <section class="wrapper_inputs">
                    <div class="button btn_menu_language black30" v-for="(market, index) in App.user.markets" :key="index"
                        :class="[
                            {
                                market_selected:
                                    current_market_selected == market
                            }
                        ]">
                        <span class="item_1" @click="setAppMarket(market)">{{
                            App.entities.markets[market][
                            App.user.default_language
                            ]
                        }}</span>
                        <span class="item_2" @click="setDefaultMarketApplication(market)">
                            <i v-if="default_market_selected == market" class="icon-lock"></i>
                            <i v-else class="icon-unlock"></i>
                        </span>
                    </div>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div class="button black30" @click="closeModal">
                            {{ translations.generic.cancel }}
                        </div>
                        <div class="button" @click="setAppMarket">
                            {{ translations.market.save_market_selected }}
                        </div>
                    </span>
                    <span class="icon-close-positive-circle close" @click="closeModal"></span>
                </section>
            </div>
        </div>
        <!-- /MODAL MARKET -->

        <!-- MODAL SAVED QUERIES -->
        <div v-if="modal_type == 'modal_saved_queries'" class="modal_overlay modal_saved_queries"
            v-bind:class="{ modalShow: modal_visible }">
            <div class="box">
                <header>
                    <h2 class="modal_title">
                        {{ translations.saved_queries.title }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <section class="actions_area">
                        <div class="custom_select">
                            <span @click="
                                list_item_show =
                                list_item_show == false ? true : false
                            ">
                                <label v-bind:class="{
                                    custom_select_open: list_item_show
                                }">{{
    modal_saved_queries_market_selected
}}</label>
                                <i v-bind:class="{
                                    custom_select_open: list_item_show
                                }" class="icon-chevron-up"></i>
                            </span>
                            <ul v-bind:class="{
                                custom_select_open: list_item_show
                            }">
                                <li @click="setMarketSavedQueries(market)" v-for="(market, index) in markets" :key="index">
                                    <span class="item_1">{{
                                        App.entities.markets[market][
                                        App.user.default_language
                                        ]
                                    }}</span>
                                    <span class="item_1">{{
                                        App.entities.markets[market][
                                        App.user.default_langauge
                                        ]
                                    }}</span>
                                </li>
                            </ul>
                        </div>
                        <nav>
                            <a v-bind:class="{
                                selected:
                                    current_view_panel_saved_queries ==
                                    'own'
                            }" @click="toogleSavedQueriesView('own')">{{
    App.translations.generic.own_save_queries[
    App.selected_language
    ]
}}
                                ({{ own_saved_queries.length }})</a>
                            <a v-bind:class="{
                                selected:
                                    current_view_panel_saved_queries ==
                                    'market'
                            }" @click="toogleSavedQueriesView('market')">{{
    App.translations.generic
        .market_save_queries[
    App.selected_language
    ]
}}
                                ({{ market_saved_queries.length }})</a>
                        </nav>
                    </section>
                    <section>
                        <header class="info_results_table">
                            <span class="id"></span>
                            <span v-bind:class="[
                                {
                                    title_admin:
                                        !is_admin &&
                                        current_view_panel_saved_queries ==
                                        'market'
                                },
                                'query_title'
                            ]" class="query_title">{{ translations.generic.query_title }}</span>
                            <span class="apply_action">{{
                                translations.generic.apply
                            }}</span>
                            <span class="edit_action">{{
                                translations.generic.edit
                            }}</span>
                            <span v-if="current_view_panel_saved_queries == 'own'" class="delete_action">{{
                                translations.generic.delete }}</span>
                            <span v-if="
                                is_admin &&
                                current_view_panel_saved_queries == 'market'
                            " class="delete_action">{{ translations.generic.delete }}</span>
                        </header>
                        <section class="results_queries_saved" v-if="current_view_panel_saved_queries == 'own'">
                            <div class="saved_query_item" v-for="(saved_query, index) in own_saved_queries" :key="index">
                                <span v-if="
                                    entities.markets[saved_query.id_market][
                                    current_language
                                    ] == current_market
                                ">
                                    <span class="id">{{ index + 1 }}</span>
                                    <span class="query_title">{{
                                        saved_query.name
                                    }}</span>
                                    <span @click="
                                        queryFunctionSelected(
                                            saved_query,
                                            'apply'
                                        )
                                    " class="apply_action">
                                        <span class="circle_icon">
                                            <i class="icon-query"></i>
                                        </span>
                                    </span>
                                    <span @click="
                                        queryFunctionSelected(
                                            saved_query,
                                            'edit'
                                        )
                                    " class="edit_action">
                                        <span class="circle_icon">
                                            <i class="icon-edit"></i>
                                        </span>
                                    </span>
                                    <span @click="
                                        queryFunctionSelected(
                                            saved_query,
                                            'delete'
                                        )
                                    " class="delete_action">
                                        <span class="circle_icon">
                                            <i class="icon-delete"></i>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </section>
                        <section class="results_queries_saved" v-if="current_view_panel_saved_queries == 'market'">
                            <div class="saved_query_item" v-for="(saved_query, index ) in market_saved_queries"
                                :key="index">
                                <span>
                                    <span class="id">{{ index + 1 }}</span>
                                    <span v-bind:class="[
                                        { title_admin: !is_admin },
                                        'query_title'
                                    ]">{{ saved_query.name }}</span>
                                    <span @click="
                                        loadQuerySelected(
                                            saved_query
                                        )
                                    " class="apply_action">
                                        <span class="circle_icon">
                                            <i class="icon-query"></i>
                                        </span>
                                    </span>
                                    <span @click="
                                        queryFunctionSelected(
                                            saved_query,
                                            'edit'
                                        )
                                    " class="edit_action">
                                        <span class="circle_icon">
                                            <i class="icon-edit"></i>
                                        </span>
                                    </span>
                                    <span v-if="is_admin" @click="
                                        queryFunctionSelected(
                                            saved_query,
                                            'delete'
                                        )
                                    " class="delete_action">
                                        <span class="circle_icon">
                                            <i class="icon-delete"></i>
                                        </span>
                                    </span>
                                </span>
                            </div>
                        </section>
                    </section>
                    <span class="icon-close-positive-circle close" @click="closeModal"></span>
                </section>
            </div>
        </div>
        <div v-if="modal_type == 'modal_saved_queries'" class="modal_overlay confirm_modal_saved_queries"
            v-bind:class="{ modalShow: confirm_modal_visible }">
            <div class="box">
                <header>
                    <h2 class="modal_title">
                        {{ translations.saved_queries_confirm.title }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <div class="content">
                        <p v-if="selected_query_action !== ''">
                            {{
                                App.translations.modals[selected_query_action][
                                'content'
                                ][App.selected_language]
                            }}
                        </p>
                    </div>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div class="button black30" @click="resetActionQuery">
                            {{ translations.generic.cancel }}
                        </div>
                        <div v-if="selected_query_action !== ''" class="button" @click="confirmActionQuery">
                            {{
                                App.translations.modals[selected_query_action][
                                'btn_action'
                                ][App.selected_language]
                            }}
                        </div>
                    </span>
                </section>
            </div>
        </div>
        <!-- /MODAL SAVED QUERIES -->
        <!-- MODAL SAVE QUERY -->
        <div v-if="modal_type == 'modal_save_query'" class="modal_overlay modal_save_query"
            v-bind:class="{ modalShow: modal_visible }">
            <div class="box medium">
                <header>
                    <h2 class="modal_title">
                        {{ translations.generic.title_save_queries }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <p class="content">
                        {{ translations.generic.content_save_queries }}
                    </p>
                    <p class="inputs_info uppercase">
                        {{ translations.generic.inputs_info_save_queries }}
                    </p>
                    <span class="type_input">
                        <input class="inputs_content" v-model="save_query_title" />
                    </span>
                    <div v-if="is_admin">
                        <p class="inputs_info uppercase">
                            {{ translations.generic.place_to_save_queries }}
                        </p>
                        <span class="type_input tab_selector_wrapper">
                            <span @click="toggleKindSaveQuerySwitch('own')" v-bind:class="{
                                selected: current_save_query_to == 'own'
                            }" class="tab_selector">{{
    translations.generic.own_save_queries
}}</span>
                            <span @click="toggleKindSaveQuerySwitch('market')" v-bind:class="{
                                selected: current_save_query_to == 'market'
                            }" class="tab_selector">{{
    translations.generic.market_save_queries
}}</span>
                        </span>
                    </div>
                    <span class="line_separator"></span>
                    <div class="wrapper-buttons">
                        <div @click="closeModal" class="button black30">
                            {{ translations.generic.cancel }}
                        </div>
                        <div @click="saveQuery" class="button" v-if="current_query.market_query && !is_admin">
                            {{ translations.generic.save_as_own }}
                        </div>
                        <div @click="saveQuery" class="button" v-else>
                            {{ translations.generic.saved_queries }}
                        </div>
                    </div>
                    <span class="icon-close-positive-circle close" @click="closeModal"></span>
                </section>
            </div>
        </div>
        <div v-if="modal_type == 'modal_save_query' && confirm_modal_visible"
            class="modal_overlay modal_save_or_update_query" v-bind:class="{ modalShow: confirm_modal_visible }">
            <div class="box small">
                <header>
                    <h2 class="modal_title">
                        {{
                            App.translations.modals['clean_filters'].title[
                            App.selected_language
                            ]
                        }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <p class="content">
                        {{
                            App.translations.modals['clean_filters'].content[
                            App.selected_language
                            ]
                        }}
                    </p>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div @click="saveQueryCall" class="button black30">
                            {{ translations.generic.save_new }}
                        </div>
                        <div @click="updateQueryCall" class="button">
                            {{ translations.generic.update }}
                        </div>
                    </span>
                    <span class="icon-close-positive-circle close" @click="closeModalConfirmSaveQuery"></span>
                </section>
            </div>
        </div>
        <!-- /MODAL SAVE QUERY -->
        <!-- MODAL CLEAN FILTERS SELECTED -->
        <div v-if="modal_type == 'modal_clean_filters_selected'" class="modal_overlay modal_clean_filters_selected"
            v-bind:class="{ modalShow: modal_visible }">
            <div class="box small">
                <header>
                    <h2 class="modal_title">
                        {{
                            App.translations.modals['save_query'].title[
                            App.selected_language
                            ]
                        }}
                    </h2>
                </header>
                <section class="wrapper_inputs">
                    <p class="content">
                        {{
                            App.translations.modals['save_query'].content[
                            App.selected_language
                            ]
                        }}
                    </p>
                    <span class="line_separator"></span>
                    <span class="wrapper-buttons">
                        <div @click="closeModal" class="button black30">
                            {{ translations.generic.cancel }}
                        </div>
                        <div @click="isCleanFiltersConfirm" class="button">
                            {{ translations.generic.accept }}
                        </div>
                    </span>
                    <span class="icon-close-positive-circle close" @click="closeModal"></span>
                </section>
            </div>
        </div>
        <!-- /MODAL CLEAN FILTERS SELECTED -->
    </div>
</template>

<script>
import App from './../application.js'
import comp_modal_overlay_confirm from './comp_modal_overlay_confirm.vue'

export default {
    components: {
        comp_modal_overlay_confirm
    },
    data: function () {
        var current_query = App.current_query;
        var default_market = App.user.default_market;
        var current_market = App.selected_market_solutions;

        return {
            is_admin: (App.user.scopes.indexOf("marketadmin") > -1),
            lang_key: '',
            languages: App.user.languages,
            current_language: App.selected_language,
            current_market: App.entities.markets[App.selected_market_solutions][App.selected_language],
            current_market_code: App.entities.markets[App.selected_market_solutions][App.selected_language].toLocaleLowerCase(),
            markets: App.user.markets,
            modal_saved_queries_market_selected: App.entities.markets[App.selected_market_solutions][App.user.default_language],
            translations: {
                generic: App.current_translations['generic'],
                languages: App.current_translations['languages'],
                menu_lang: App.current_translations['menu_lang'],
                saved_queries: App.current_translations['saved_queries'],
                saved_queries_confirm: App.current_translations['saved_queries_confirm'],
                markets: App.current_translations['markets'],
                market: App.current_translations['market'],
                modals: App.current_translations['modals']
            },
            //general
            unex_lib: App.unex_lib,
            App: App,
            modal_visible: false,
            modal_type: '',
            // modal language
            default_lang_application: App.user.default_language_solutions,
            current_language_selected: App.selected_language_solutions,
            //modal market
            default_market_selected: default_market,
            current_market_selected: current_market,
            //saved queries
            own_saved_queries: [],
            market_saved_queries: [],
            current_view_panel_saved_queries: 'own',
            list_item_show: false,
            confirm_modal_visible: false,
            selected_query_item: '',
            // save query
            save_query_title: (Object.keys(current_query).length !== 0) ? current_query.name : '',
            current_save_query_to: (!(App.user.scopes.indexOf("marketadmin") > -1) || (App.user.scopes.indexOf("marketadmin") > -1 && Object.keys(current_query).length !== 0 && !current_query.market_query)) ? 'own' : 'market',
            selected_query_action: 'delete',
            current_query: current_query
        }
    },
    mounted: function () {
        var self = this;
        App.bus.$on('modal_logout', function () {
            self.modal_type = 'modal_logout';
            self.modal_visible = true;
        });
        App.bus.$on('modal_language', function () {
            self.modal_visible = true;
            self.modal_type = 'modal_language';
        });
        App.bus.$on('saveChangeLanguageApp', function () {
            self.modal_saved_queries_market_selected = App.entities.markets[App.selected_market_solutions][App.user.default_language];
            self.modal_visible = false;
        });
        App.bus.$on('modal_market', function () {
            self.modal_visible = true;
            self.modal_type = 'modal_market';
        });
        App.bus.$on('modal_saved_queries', function (tab) {
            if (tab != "" && tab != undefined) {
                self.toogleSavedQueriesView(tab);
            }
            self.modal_saved_queries_market_selected = App.entities.markets[App.selected_market_solutions][App.user.default_language];
            if (self.own_saved_queries.length == 0 && self.market_saved_queries.length != 0) {
                self.toogleSavedQueriesView("market");
            } else {
                self.toogleSavedQueriesView("own");
            }
            self.modal_visible = true;
            self.modal_type = 'modal_saved_queries';
        });
        App.bus.$on('modal_save_query', function () {
            self.modal_visible = true;
            self.modal_type = 'modal_save_query';
            self.confirm_modal_visible = false;
        });
        App.bus.$on('modal_clean_filters_selected', function () {
            self.modal_visible = true;
            self.modal_type = 'modal_clean_filters_selected';
        });
        App.bus.$on('loaded_query', (function (query) {
            if (Object.keys(query).length !== 0) {
                this.$root.$data.current_query = query;
            }
        }).bind(this));

        App.bus.$on('load_query', function (query) {
            App.selected_market_solutions = query.id_market;
            self.setMarketApplication(query.id_market);
            App.bus.$emit('refreshFilters');
        });

        App.bus.$on('launch_query', function (query) {
            App.selected_market_solutions = query.id_market;
            self.setMarketApplication(query.id_market);
            App.bus.$emit('refreshFilters');
        });

        App.bus.$on('saveChangeMarketApp', function (current_market, default_market) {
            App.showLoader(
                1,
                (function (current_market) {
                    self.setMarketApplication(current_market);
                    App.selected_market_solutions = current_market;
                    self.changeMarket(current_market);
                    self.modal_visible = false;
                    App.bus.$emit('hide_loader', 'changeMarket');
                }).bind(this),
                current_market
            );
        });

        App.bus.$on('clean_loaded_query', function () {
            self.current_query = {};
            self.save_query_title = "";
            self.$root.$data.current_query = {};
        });

        self.own_saved_queries = self.getOwnSavedQueries();
        self.market_saved_queries = self.getMarketSavedQueries();
        self.market_selected = self.translations.markets[(App.entities.markets[App.selected_market_solutions][App.selected_language])];
        self.market_selected_code = App.entities.markets[App.selected_market_solutions][App.selected_language];
    },
    update: async function () {
        this.own_saved_queries = await this.getOwnSavedQueries();
        this.market_saved_queries = await this.getMarketSavedQueries();
    },
    methods: {
        changeMarket: function (market) {
            this.modal_saved_queries_market_selected = App.entities.markets[market][App.user.default_language];
            //this.modal_saved_queries_market_selected = App.translations.markets[unex_lib.markets[market][App.selected_language].toLocaleLowerCase()][App.selected_language];
            this.list_item_show = false;
            this.own_saved_queries = this.getOwnSavedQueries(market);
            this.market_saved_queries = this.getMarketSavedQueries(market);
            this.current_market = App.entities.markets[market][App.selected_language];
            sessionStorage.unex_lib = null;
            sessionStorage.unex_lib = JSON.stringify(App.unex_lib);
            this.current_query = {};
            this.save_query_title = "";
            this.$root.$data.current_query = {};

            this.updateSavedQueries()
        },
        logOut: function () {
            sessionStorage.unex_lib = null;
            document.location.href = '/';
        },
        updateSavedQueries: async function () {
            this.own_saved_queries = await this.getOwnSavedQueries();
            this.market_saved_queries = await this.getMarketSavedQueries();
        },
        closeModal: function () {
            this.current_market_code = App.entities.markets[App.selected_market_solutions][App.selected_language].toLocaleLowerCase();
            this.current_market_selected = App.selected_market_solutions;
            this.default_market_selected = App.user.default_market;
            this.current_language = App.selected_language;
            this.default_lang_application = App.user.default_language_solutions;
            this.current_language_selected = App.selected_language_solutions;
            this.modal_visible = false;
            this.current_market = App.entities.markets[App.selected_market_solutions][App.selected_language];
            this.own_saved_queries = this.getOwnSavedQueries();
            this.market_saved_queries = this.getMarketSavedQueries();
        },
        closeModalConfirmSaveQuery: function () {
            this.confirm_modal_visible = false;
        },
        setLanguageApplication: function (lang_key) {
            this.current_language_selected = lang_key;
        },
        setDefaultLanguageApplication: function (lang_key) {
            this.default_lang_application = lang_key;
        },
        setAppMarket: async function (market) {
            App.setMarket(market)

            // TODO: requery
            await App.entities.init();
            App.query.clean();

            this.closeModal();
        },
        setAppLanguage: async function () {
            // TODO: comprovar què fa això
            // App.unex_lib.setDefaultLanguageSolutions(this.default_lang_application);
            // App.unex_lib.setLanguageSolutions(this.current_language_selected);
            // App.unex_lib.setLanguage(this.current_language_selected);
            App.setLanguage(this.current_language_selected);

            // TODO: requery
            await App.entities.init();
            App.query.clean();

            App.bus.$emit('refreshFilters');
            App.bus.$emit('onChangeModalLanguage');
            this.closeModal();
            return;
            App.showLoader(
                2,
                (function () {
                    App.unex_lib.setDefaultLanguageSolutions(this.default_lang_application);
                    App.unex_lib.setLanguageSolutions(this.current_language_selected);
                    App.unex_lib.setLanguage(this.current_language_selected);
                    App.setLanguage(this.current_language_selected);
                    App.bus.$emit('refreshFilters');
                    App.bus.$emit('onChangeModalLanguage');
                }).bind(this),
                {},
                (function () {
                    this.closeModal();
                }).bind(this)
            );
        },
        //market modal
        setMarketApplication: function (market_key) {
            this.current_market_selected = market_key;
            this.current_market_code = App.entities.markets[market_key][App.selected_language].toLocaleLowerCase();
        },
        setDefaultMarketApplication: function (market_key) {
            this.default_market_selected = market_key;
        },
        // setAppMarket: function () {
        //     App.bus.$emit('confirmChangeMarketModal', {
        //         'current_market_selected': this.current_market_selected,
        //         'default_market_selected': this.default_market_selected
        //     });
        // },
        //saved queries
        queryFunctionSelected: function (query_selected, action) {
            // TODO: refer
            this.selected_query_item = query_selected;
            this.selected_query_action = action;
            if (this.selected_query_action != 'delete') {
                this.confirmActionQuery();
            } else {
                this.modal_visible = true;
                this.confirm_modal_visible = true;
            }
        },
        loadQuerySelected: function (query_selected) {
            App.query.loadSavedQuery(query_selected);
            this.closeModal();
        },
        resetActionQuery: function () {
            this.confirm_modal_visible = false;
            this.selected_query_item = {};
            this.selected_query_action = '';
        },
        confirmActionQuery: function () {
            switch (this.selected_query_action) {
                case 'apply':
                    // App.bus.$emit('launch_query', selected_query_item);
                    // App.showLoader(
                    //     1,
                    //     (function (selected_query_item) {
                    //         this.$root.$data.current_query = selected_query_item;
                    //         App.bus.$emit('launch_query', selected_query_item);
                    //     }).bind(this),
                    //     this.selected_query_item
                    // );
                    break;
                case 'edit':
                    App.showLoader(
                        3,
                        (function (selected_query_item) {
                            this.$root.$data.current_query = selected_query_item;
                            App.bus.$emit('load_query', selected_query_item);
                            App.root_activated_view = 'query_filters';
                        }).bind(this),
                        this.selected_query_item
                    );
                    break;
                case 'delete':
                    App.showLoader(
                        1,
                        (function (selected_query_item) {
                            App.bus.$emit('delete_query', selected_query_item.id);
                            if (selected_query_item.id == this.current_query.id) {
                                this.current_query = {};
                                this.save_query_title = "";
                                this.$root.$data.current_query = {};
                                App.bus.$emit('is_clean_query');
                                App.root_activated_view = 'query_filters';
                            }
                            App.unex_lib.deleteQuery(selected_query_item.id);
                            this.own_saved_queries = this.getOwnSavedQueries();
                            this.market_saved_queries = this.getMarketSavedQueries();
                            App.bus.$emit('hide_loader', 'delete_query_modal');
                        }).bind(this),
                        this.selected_query_item
                    );
                    break;
            }
            this.resetActionQuery();
            this.modal_visible = false;
        },
        getOwnSavedQueries: async function (market) {
            var selected_market = (market !== undefined) ? market : App.selected_market_solutions;
            return await App.query.getStoredQueries(selected_market);
        },
        getMarketSavedQueries: async function (market) {
            var selected_market = (market !== undefined) ? market : App.selected_market_solutions;
            return await App.query.getStoredMarketQueries(selected_market);
        },
        saveQueryCall: function () {
            App.showLoader(
                1,
                (function (argument) {
                    var query = {
                        market_query: (this.current_save_query_to == 'market' && this.is_admin),
                        id_market: App.selected_market_solutions,
                        name: this.save_query_title,
                        data: App.getFilters(null)
                    };
                    var response = App.unex_lib.storeQuery(query);
                    if (response.id_query !== undefined) query.id = response.id_query;
                    this.own_saved_queries = this.getOwnSavedQueries();
                    this.market_saved_queries = this.getMarketSavedQueries();
                    this.$root.$data.current_query = query;
                    App.bus.$emit('load_query', query);
                    this.modal_visible = false;
                    this.confirm_modal_visible = false;
                    App.bus.$emit('hide_loader');
                }).bind(this)
            );
        },
        updateQueryCall: function () {
            App.showLoader(
                1,
                (function (argument) {
                    var query = {
                        id: this.current_query.id,
                        market_query: (this.current_save_query_to == 'market' && this.is_admin),
                        id_market: App.selected_market_solutions,
                        name: this.save_query_title,
                        data: App.getFilters(null)
                    };
                    App.unex_lib.storeQuery(query);
                    App.bus.$emit('load_query', query);
                    this.$root.$data.current_query = query;
                    this.own_saved_queries = this.getOwnSavedQueries();
                    this.market_saved_queries = this.getMarketSavedQueries();
                    this.modal_visible = false;
                    this.confirm_modal_visible = false;
                    App.bus.$emit('hide_loader');
                }).bind(this)
            );

        },
        saveQuery: function () {
            if (this.current_query.name != "" && this.current_query.name != null) {
                if ((this.is_admin && this.current_query.market_query) || !this.current_query.market_query) {
                    this.confirm_modal_visible = true;
                } else {
                    this.saveQueryCall();
                    this.modal_visible = false;
                }
            } else if (this.current_query.name == "" || this.current_query.name == null) {
                this.saveQueryCall();
                this.modal_visible = false;
            } else {
                this.saveQueryCall();
                this.modal_visible = false;
            }
        },
        setMarketSavedQueries: function (market) {
            this.changeMarket(market);
            if (this.own_saved_queries.length == 0 && this.market_saved_queries.length != 0) {
                this.toogleSavedQueriesView("market");
            } else {
                this.toogleSavedQueriesView("own");
            }
        },
        toogleSavedQueriesView: function (param) {
            this.current_view_panel_saved_queries = param;
        },
        toggleKindSaveQuerySwitch: function (param) {
            this.current_save_query_to = param;
        }
    }
}
</script>
